/**
 * Professional Skills Showcase - Reimagine LOHP Data
 *
 * This file contains a mapping of skill slugs to their corresponding label IDs
 * for the professional skills showcase component on the reimagine LOHP page.
 *
 * Each key represents a skill slug (URL-friendly string) and the value is the
 * corresponding label ID (number) used for categorization and filtering.
 */

export const PSU_TOPICS = {
  'artificial-intelligence': 4624,
  python: 7380,
  excel: 6730,
  'ai-agents': 583042,
  'digital-marketing': 5430,
  'amazon-aws': 4452,
  n8n: 721407,
  'english-language': 5626,
  'web-development': 8322,
  'microsoft-power-bi': 6740,
  chatgpt: 158002,
  'project-management': 7336,
  'data-science': 5336,
  javascript: 6368,
  'project-planning': 17908,
  'social-media-marketing': 7788,
  'generative-ai': 158078,
  'aws-certified-cloud-practitioner': 46868,
  'information-technology-engineers-exam': 157986,
  'unreal-engine': 8166,
  langchain: 2146122,
  midjourney: 158096,
  wordpress: 8452,
  'dutch-language': 5516,
  'personal-finance': 7140,
  sql: 7862,
  java: 6336,
  'software-testing': 7812,
  photoshop: 4402,
  math: 6646,
  'affiliate-marketing': 4416,
  'italian-language': 6330,
  'c-plus-plus': 4908,
  figma: 46554,
  'video-editing': 8210,
  'prompt-engineering': 158142,
  'rust-programming-language': 25978,
  react: 7450,
  'cisco-ccna': 5044,
  'aws-certified-solutions-architect-associate': 24774,
  'human-resources': 6154,
  'machine-learning': 6594,
  'front-end-web-development': 5884,
  'data-analysis': 5328,
  odoo: 6970,
  'business-strategy': 4898
};
export const PSU_TOPICS_BY_LOCALE = {
  en: ['artificial-intelligence', 'python', 'excel', 'ai-agents', 'digital-marketing', 'amazon-aws'],
  es: ['artificial-intelligence', 'python', 'excel', 'n8n', 'english-language', 'digital-marketing'],
  pt: ['artificial-intelligence', 'excel', 'python', 'microsoft-power-bi', 'english-language', 'digital-marketing'],
  de: ['artificial-intelligence', 'python', 'excel', 'ai-agents', 'digital-marketing', 'chatgpt'],
  fr: ['n8n', 'python', 'excel', 'microsoft-power-bi', 'chatgpt', 'project-management'],
  id: ['python', 'digital-marketing', 'data-science', 'excel', 'javascript', 'project-planning'],
  it: ['chatgpt', 'excel', 'python', 'english-language', 'social-media-marketing', 'artificial-intelligence'],
  ja: ['generative-ai', 'python', 'chatgpt', 'aws-certified-cloud-practitioner', 'web-development', 'information-technology-engineers-exam'],
  ko: ['chatgpt', 'python', 'unreal-engine', 'langchain', 'artificial-intelligence', 'web-development'],
  nl: ['midjourney', 'excel', 'python', 'wordpress', 'dutch-language', 'personal-finance'],
  pl: ['chatgpt', 'sql', 'web-development', 'java', 'software-testing', 'microsoft-power-bi'],
  ro: ['excel', 'photoshop', 'math', 'affiliate-marketing', 'italian-language', 'c-plus-plus'],
  ru: ['chatgpt', 'figma', 'web-development', 'sql', 'software-testing', 'video-editing'],
  th: ['prompt-engineering', 'python', 'rust-programming-language', 'web-development', 'react', 'cisco-ccna'],
  tr: ['chatgpt', 'english-language', 'python', 'excel', 'data-science', 'web-development'],
  vi: ['chatgpt', 'python', 'project-management', 'amazon-aws', 'aws-certified-solutions-architect-associate', 'human-resources'],
  zh: ['generative-ai', 'python', 'machine-learning', 'chatgpt', 'front-end-web-development', 'data-analysis'],
  ar: ['artificial-intelligence', 'excel', 'odoo', 'project-management', 'business-strategy', 'digital-marketing']
};
export function getProfessionalSkillsShowcaseDataByLocale(locale) {
  const topicSlugs = !PSU_TOPICS_BY_LOCALE[locale] ? PSU_TOPICS_BY_LOCALE['en'] : PSU_TOPICS_BY_LOCALE[locale];
  return {
    type: 'professional_skills',
    items: [],
    view_type: 'horizontal_tabbed',
    available_filters: {
      units: topicSlugs.map(slug => {
        return {
          id: 8,
          category_id: 288,
          num_enrollments: 80360082,
          items: [],
          available_filters: {
            units: [{
              label_id: PSU_TOPICS[slug],
              url: `/api-2.0/discovery-units/bestseller/?apply_campaign_filter=False&context=home&fft=skills_hub_top_new_beginner&fl=lbl&is_content_rankable=False&label_id=${PSU_TOPICS[slug]}&member_of=skills_hub_top_new_beginner&safe_for_public_caching=True&sos=pl&source_page=logged_out_homepage&skip_language_filter_for_aggregator=true`
            }]
          },
          source_objects: [{
            url: `/topic/${slug}/`
          }]
        };
      })
    }
  };
}
//# sourceMappingURL=professional-skills-showcase-reimagine-lohp.js.map